/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {fetchProxy} from "../APIClient.jsx";

export const CatalogAPI = function () {

    function list() {
        let parameter = {}
        return fetchProxy("catalog/list", parameter)
    }

    function find(catalogName) {
        let parameter = {}
        parameter.catalogName = catalogName;
        return fetchProxy("catalog/find", parameter)
    }

    function info(catalogId) {
        let parameter = {}
        parameter.catalogId = catalogId;
        return fetchProxy("catalog/info", parameter)
    }

    function remove(catalogId) {
        let parameter = {}
        parameter.catalogId = catalogId;
        return fetchProxy("catalog/remove", parameter)
    }

    function action(catalogId, actionName) {
        let parameter = {}
        parameter.catalogId = catalogId;
        parameter.actionName = actionName;
        return fetchProxy("catalog/action", parameter)
    }


    return {
        list,
        find,
        info,
        remove,
        action
    }
}()